import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LottieModule } from 'ngx-lottie';
import { DialogOptions } from 'src/app/interfaces/dialog-data.interface';
import { OnGetData } from 'src/app/services/dialog.service';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';

@Component({
  selector: 'app-raw-upload-paywall-dialog',
  standalone: true,
  imports: [CommonModule, RouterLink, LottieModule, ButtonDirective],
  templateUrl: './raw-upload-paywall-dialog.component.html',
  styleUrls: ['./raw-upload-paywall-dialog.component.scss'],
})
export class RawUploadPaywallDialogComponent implements OnGetData {
  dialogName = 'raw-upload-paywall';
  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 40, spacingY: 40 };
  }
}
